module.exports = __webpack_public_path__ + "media/images/categoryIcons/education_icon-6b1501ced82699ed24203ea7884d79a6.svg";